import React from 'react';
import { Button } from '../../Components/Button';
import { Tooltip } from '../../Components/Tooltip';
import { useStyletron } from '../../Themes';
import { paddingSize, CloseIcon } from './Theming';

/**
 * Used in Feedback and Notification components
 */
export const CloseButtonComponent = ({ onClick, color, style = {} }: any) => {
	const [css] = useStyletron();
	const onKeyPress = (e: any) => {
		const enterOrSpace =
			e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.which === 13 || e.which === 32;
		if (enterOrSpace) {
			e.preventDefault();
			onClick(e);
		}
	};

	return (
		<div className={css(style)}>
			<Tooltip content="Close">
				<Button
					onKeyPress={onKeyPress}
					onClick={onClick}
					theme="minimal"
					aria-label="Close"
					overrides={{
						BaseButton: {
							style: {
								...paddingSize('0', '0', '0', '0'),
								':hover': { backgroundColor: 'transparent' },
								color: color || 'var(--epods--color-text-primary)',
							},
						},
					}}
				>
					<CloseIcon size="large" />
				</Button>
			</Tooltip>
		</div>
	);
};
